module.exports = __webpack_public_path__ + "img/manqrphn.png";